export * from '@macs-frontend/features/ui-kit/base';
